import { Injectable, inject } from '@angular/core';
import { ChatUserSettings, UserDataExchange, UserDataExchangeAbstractService } from '@dataclouder/ngx-agent-cards';
import { LangCodeDescription } from '@dataclouder/ngx-lessons';

import { UserService } from './data-services/user.service';
import { LevelDescription } from './lexicore/lexicore.classes';

@Injectable({
  providedIn: 'root',
})
export class UserDataExchangeService implements UserDataExchangeAbstractService {
  getUserDataInformation(): string {
    return this.getUserDataDescriptions()
      .map((desc) => `(${desc.key}) ${desc.description}: ${desc.value}`)
      .join('\n');
  }

  private userService = inject(UserService);

  getUserDataDescriptions(): { key: string; value: unknown; description: string }[] {
    const user = this.userService.getUserSnapshot();
    const settings = this.userService.getUserSnapshot().settings;
    const level = user.languageProgress[settings.targetLanguage]?.level;
    const decriptions = [
      { key: 'name', value: user.personalData?.emotionalName || user.personalData?.firstname || 'Usuario', description: 'Name of the user' },
      { key: 'gender', value: user.personalData.gender, description: 'Gender of the user' },
      { key: 'baseLang', value: LangCodeDescription[settings.baseLanguage], description: 'Base language of the user' },
      { key: 'targetLang', value: LangCodeDescription[settings.targetLanguage], description: 'Target language of the user' },
      { key: 'level', value: level, description: 'Level of the user' },
      { key: 'levelDesc', value: LevelDescription[level], description: 'Level description of the user' },
    ];

    if (user?.personalData?.birthday) {
      decriptions.push({
        key: 'age',
        value: `${new Date().getFullYear() - new Date(user.personalData.birthday).getFullYear()}`,
        description: 'Age of the user',
      });
    }

    return decriptions;
  }

  getUserDataExchange(): UserDataExchange {
    const user = this.userService.getUserSnapshot();
    const settings = this.userService.getUserSnapshot().settings;
    return {
      name: user.personalData?.emotionalName || user.personalData?.firstname || 'Usuario',
      gender: user.personalData?.gender,
      age: new Date().getFullYear() - new Date(user.personalData?.birthday).getFullYear(),
      baseLang: settings.baseLanguage,
      targetLang: settings.targetLanguage,
      imgUrl: user.urlPicture,
    };
  }

  getParseDict(): { [key: string]: string } {
    // sustituye todos los {{char}} {{user}} {{target}} {{base}} por el valor de la propiedad

    const userData = this.getUserDataExchange();

    let target, base;
    try {
      target = LangCodeDescription[userData.targetLang];
      base = LangCodeDescription[userData.baseLang];
    } catch (error) {
      console.warn('Failed to get language descriptions', error);
    }

    // TODO: note check how the char is used, this parseDict need to be merged with the one for char data.
    return {
      // char: userData.name,
      user: userData.name,
      target: target || 'en',
      base: base || 'es',
    };
  }

  getUserChatSettings(): ChatUserSettings {
    const settings = this.userService.getUserSnapshot().settings.conversation as ChatUserSettings;
    return settings;
  }
}
